var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":_vm.$style.main}},[_c('main-home-visual'),_c('about-home-visual'),_c('customer-home-visual'),_c('hideki-info-home-visual'),_c('shop-home-visual'),_c('present-home-visual'),_c('banner-home-visual')],1)}
var staticRenderFns = []

export { render, staticRenderFns }